import { createAsyncThunk } from '@reduxjs/toolkit'
import Axios from 'axios'
import { $post } from '../../../../../utils/apis/http-client'
import { REQUEST_ABORTED_CODE } from '../../../common/constants'
import { getResultState } from '../selectors'
import { createGenericSlice } from '../../../../../utils/slices'

let controller = new AbortController()

const getHurricaneTiesData = createAsyncThunk(
  'request/hurricaneTies',
  async (body = {}, { rejectWithValue }) => {
    try {
      const response = await $post(`/api/RoofToWall`, body, {
        signal: controller.signal,
      })
      return { query: body, result: response.data }
    } catch (err) {
      return rejectWithValue(Axios.isCancel(err) ? { status: REQUEST_ABORTED_CODE } : err.response)
    }
  },
  {
    condition: (_, { getState }) => {
      const { loading } = getResultState(getState())

      if (loading === 'pending') {
        // Already fetched or in progress, don't need to re-fetch
        controller.abort()
        controller = new AbortController()
      }
    },
  },
)

export const resultSlice = createGenericSlice({
  name: 'result',
  initialState: {
    loading: null,
    data: [],
    query: '',
    error: '',
    optimized: true,
    searchKeyword: '',
    sortBy: [{ id: 'ici', desc: false }],
    selectedModel: null,
  },
  reducers: {
    createOutputQuery: (state, action) => {
      state.query = action.payload
    },
    setOptimized: (state) => {
      state.optimized = !state.optimized
    },
    setSearchKeyword: (state, action) => {
      state.searchKeyword = action.payload
    },
    setSelectedModel: (state, action) => {
      state.selectedModel = action.payload
    },
    // updateCalculation: updateAction,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHurricaneTiesData.pending, (state) => {
        state.loading = 'pending'
        state.error = ''
      })
      .addCase(getHurricaneTiesData.fulfilled, (state, action) => {
        const { result } = action.payload
        let loading = ''
        let data = ''
        let error = ''

        if (
          result === 'Sorry there is a problem to Run the SST Connector Web API' ||
          typeof result === 'string'
        ) {
          loading = 'failed'
          error =
            'The network connection is currently unavailable to generate results. Please try your calculations again at a later time.'
        } else {
          const { htOutputs, errors } = result // action.payload
          loading = 'succeeded'
          data = htOutputs
          error = errors
        }
        state.loading = loading
        state.data = data
        state.error = error
      })
      .addCase(getHurricaneTiesData.rejected, (state, action) => {
        if (action.payload) {
          const { title: error, status } = action.payload
          switch (status) {
            case REQUEST_ABORTED_CODE:
              break
            default:
              state.loading = 'failed'
              state.error = error
              break
          }
        } else if (action.error) {
          // test case : token is valid then disconnect Wi-Fi then trigger calculation
          state.loading = 'failed'
          state.error =
            'The network connection is currently unavailable to generate results. Please try your calculations again at a later time.'
        }

        state.data = []
      })
  },
})

export const resultActions = { ...resultSlice.actions, getHurricaneTiesData }
